import React, { Component } from "react";
import PropTypes from "prop-types";
import { filter } from "lodash";
import Draggable from "react-draggable";

import IconButton from "material-ui/IconButton";
import ActionClose from "material-ui/svg-icons/action/highlight-off";
import ActionDelete from "material-ui/svg-icons/action/delete";
import { connect } from "../utils";
import { DivCointainer, DivHeaderActions } from "./styled";
import "./index.css";

class PropsEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPlugin: 0,
      controlledPosition: {
        x: 0,
        y: 0
      }
    };
    this.onControlledDrag = this.onControlledDrag.bind(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   // const rootBody = document.getElementById(`root`);
  //   // if (rootBody) {
  //   //   const getDome = rootBody.getBoundingClientRect();
  //   //   const yComponent = getDome.height - getDome.bottom;
  //   //   this.setState({
  //   //     controlledPosition: {
  //   //       x: this.state.controlledPosition.x,
  //   //       y: yComponent || 0
  //   //     }
  //   //   });
  //   // }
  // }
  handlePluginChange = e => {
    this.setState({ currentPlugin: e.target.value });
  };
  handleClose = layoutState => {
    layoutState.setSelectedItem(null);
  };
  onControlledDrag(e, position) {
    const { x, y } = position;
    this.setState({ controlledPosition: { x, y } });
  }
  onDelete = layoutState => {
    if (
      layoutState.getItemJS(layoutState.selectedItem).type === "ContentCarousel"
    ) {
      const item = layoutState.getItemJS(layoutState.selectedItem);
      const parent = layoutState.getItemJS(item.parent.id);
      let newProps = parent.props;
      if (parent.children.length > 1) {
        layoutState.removeItem(layoutState.selectedItem);

        if (item.id === newProps.values.carousel.keyActive) {
          let newParent = layoutState.getItemJS(item.parent.id).props;
          let newChildren = filter(
            layoutState.getItemJS(item.parent.id).children,
            function(o) {
              return o !== item.id;
            }
          );
          newParent.values.carousel.keyActive = newChildren[0];
        }
      }
    } else {
      layoutState.removeItem(layoutState.selectedItem);
    }
  };
  render() {
    const { layoutState, addons } = this.props;
    let selectedItem = layoutState.getSelectedItem();
    let isRooted = selectedItem && selectedItem.id === "root" ? false : true;

    let Plugin = addons[this.state.currentPlugin].Interface || (() => null);
    let isOPen =
      selectedItem && selectedItem.type !== "Content"
        ? "slide-out"
        : "slide-in";

    return (
      <Draggable
        handle="strong"
        position={this.state.controlledPosition}
        onDrag={this.onControlledDrag}
      >
        <DivCointainer className={isOPen}>
          {selectedItem && (
            <div>
              <strong>
                <DivHeaderActions>
                  <IconButton
                    onClick={() => this.handleClose(layoutState)}
                    iconStyle={{ color: "#FFFFFF" }}
                  >
                    <ActionClose />
                  </IconButton>
                  {isRooted && (
                    <IconButton
                      onClick={() => this.onDelete(layoutState)}
                      iconStyle={{ color: "#FFFFFF" }}
                    >
                      <ActionDelete />
                    </IconButton>
                  )}
                </DivHeaderActions>
              </strong>
              <Plugin
                layoutState={layoutState}
                typePage={this.props.typePage}
                marketerId={this.props.marketerId}
              />
            </div>
          )}
        </DivCointainer>
      </Draggable>
    );
  }
}
/*<Breadcrumb /><select onChange={this.handlePluginChange} value={this.state.currentPlugin}>
  {addons.map((addon, idx) => addon.Interface ? (
    <option key={addon.Title} value={idx}>{addon.Title}</option>
  ) : null )}
</select>*/
PropsEditor.propTypes = {
  addons: PropTypes.array,
  typePage: PropTypes.string,
  marketerId: PropTypes.string
};

export default connect(
  "layoutState",
  "addons"
)(PropsEditor);



// WEBPACK FOOTER //
// ./src/editor/layout/editor/PropsEditor.js